import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NotificationFilterService } from './notification-filter.service';
import { Subscription } from 'rxjs';

export interface FilterOptions {
  typeFilters: string[];
  statusFilters: string[];
  countryFilters: string[];
  searchText: string;
}
@Component({
  selector: 'dl-notification-filter',
  templateUrl: './notification-filter.component.html',
  styleUrls: ['./notification-filter.component.scss']
})
export class NotificationFilterComponent implements OnInit, OnDestroy {
  public width = '240px';
  public widthStatus = '240px';
  public widthCountry = '240px';
  public formDisabled = false;

  public typeFormControl = new FormControl();

  public typeList = [];

  public typePlaceholder = 'Type';
  public statusFormControl = new FormControl();

  public statusList = [];

  public statusPlaceholder = 'Status';
  public typeFilters: [];
  public statusFilters: [];
  public filterDataObject: FilterOptions;

  
  public countryList = [];
  public countryFilters = [];
  public countryFormControl = new FormControl();
  public countryPlaceholder = 'Country';

  private _typeFormControlSubscription: Subscription;
  private _statusFormControlSubscription: Subscription;
  private _countryFormControlSubscription: Subscription;
  private _notificationFilterServiceSubscription: Subscription;
  public isClearVis: boolean = false;

  public constructor(private notificationFilterService: NotificationFilterService) {
    this.filterDataObject = { typeFilters: [], statusFilters: [], countryFilters: [], searchText: '' };
  }
  
  public ngOnDestroy(): void {
    this._typeFormControlSubscription.unsubscribe();
    this._statusFormControlSubscription.unsubscribe();
    this._countryFormControlSubscription.unsubscribe();
    this._notificationFilterServiceSubscription.unsubscribe();
  }

  public ngOnInit(): void {
    this._typeFormControlSubscription = this.typeFormControl.valueChanges.subscribe(val => {
      if (val && val.length > 0) {
        this.typeFilters = val.map(item => item.label.trim());
        this.filterDataObject.typeFilters = this.typeFilters;
        this.notificationFilterService.getfilteredData(this.filterDataObject);
        this.isClearVis = true;
      } else {
        this.filterDataObject.typeFilters = [];
        this.notificationFilterService.getfilteredData(this.filterDataObject);
        this.isClearVis = false;
      }
    });

    this._statusFormControlSubscription = this.statusFormControl.valueChanges.subscribe(val => {
      if (val && val.length > 0) {
        this.statusFilters = val.map(item => item.label.trim());
        this.filterDataObject.statusFilters = this.statusFilters;
        this.notificationFilterService.getfilteredData(this.filterDataObject);
        this.isClearVis = true;
      } else {
        this.filterDataObject.statusFilters = [];
        this.notificationFilterService.getfilteredData(this.filterDataObject);
        this.isClearVis = false;
      }
    });

    this._countryFormControlSubscription = this.countryFormControl.valueChanges.subscribe(val => {
      if (val && val.length > 0) {
        this.countryFilters = val.map(item => item.label.trim());
        this.filterDataObject.countryFilters = this.countryFilters;
        this.notificationFilterService.getfilteredData(this.filterDataObject);
        this.isClearVis = true;
      } else {
        this.filterDataObject.countryFilters = [];
        this.notificationFilterService.getfilteredData(this.filterDataObject);
        this.isClearVis = false;
      }
    });

    this._notificationFilterServiceSubscription = this.notificationFilterService.typeFilterobservable$.subscribe(ele => {
      if (ele.label) {
        let checkEle = true;
        this.typeList.some((el, ind) => {
          if (el.label.trim() === ele.label.trim()) {
            checkEle = false;
          }
        });
        if (checkEle) this.typeList.push(ele);
      }
      return;
    });

    this._notificationFilterServiceSubscription = this.notificationFilterService.statusFilterobservable$.subscribe(ele => {
      if (ele.label) {
        let checkEle = true;
        this.statusList.some((el, ind) => {
          if (el.label.trim() === ele.label.trim()) {
            checkEle = false;
          }
        });
        if (checkEle) this.statusList.push(ele);
      }
      return;
    });

    this._notificationFilterServiceSubscription = this.notificationFilterService.countryFilterobservable$.subscribe(ele => {
      if (ele.label) {
        let checkEle = true;
        this.countryList.some((el, ind) => {
          if (el.label.trim() === ele.label.trim()) {
            checkEle = false;
          }
        });
        if (checkEle) this.countryList.push(ele);
      }
      return;
    });
  }

  public clear(){
    this.typeFormControl.patchValue('');
    this.statusFormControl.patchValue('');
    this.countryFormControl.patchValue('');
  }
}
